import { cn } from "@/app/utils/cn";
import { Button } from "@/view/components/ui/button";
import { ArrowRight } from "lucide-react";
import { PartnerType } from "@/app/utils/partners.enum";
import { Skeleton } from "@/view/components/ui/skeleton";
interface IPartnerType {
  title: string;
  bgColor: string;
  imageSrc: string;
  description: string;
  needAuthorization: boolean;
  submit: () => void;
  type: string;
  disabledButton?: boolean;
  isLoading?: boolean;
}

export const PartnerCard = ({ isLoading, title, bgColor, imageSrc, description, needAuthorization, submit, type, disabledButton = false }: IPartnerType) => {
  const isLightText = type !== PartnerType.CLT;
  const skeletonColor = isLightText ? "bg-white/20" : "bg-black/10";

  if (isLoading) {
    return (
      <div className={cn("flex flex-col justify-between p-4 rounded-xl gap-4 flex-1 min-w-[280px]")} style={{ backgroundColor: bgColor }}>
        <div className="flex items-center justify-start">
          <Skeleton className={cn("h-14 w-24", skeletonColor)} />
          <hr className="w-px h-5 bg-transparent border-0" />
          <Skeleton className={cn("h-4 w-32 ml-4", skeletonColor)} />
        </div>

        <div className="flex flex-col gap-2">
          <Skeleton className={cn("h-3 w-full", skeletonColor)} />
          <Skeleton className={cn("h-3 w-4/5", skeletonColor)} />
          <Skeleton className={cn("h-3 w-2/3", skeletonColor)} />
        </div>

        <div className="flex w-full justify-between items-center pt-2">
          <Skeleton className={cn("h-4 w-16", skeletonColor)} />
          <Skeleton className={cn("h-4 w-4 rounded-full", skeletonColor)} />
        </div>
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col justify-between p-4 rounded-xl gap-4 cursor-pointer flex-1 w-full max-w-[480px] min-w-[280px]")} style={{ backgroundColor: bgColor }} onClick={submit}>
      <div className="flex items-center justify-start">
        <div>
          <img src={imageSrc} alt={type} className="h-14 max-w-24 object-contain" />
        </div>

        <hr className="w-px h-5 bg-yellow-500 border-0" />

        <p className={cn("cursor-pointer font-semibold text-start text-sm ml-4", type === PartnerType.CLT ? "text-black" : "text-white")}>{title}</p>
      </div>

      <p className={cn("cursor-pointer text-xs text-start", type === PartnerType.CLT ? "text-black" : "text-white")}>{description}</p>

      <Button
        variant="ghost"
        type="button"
        isLoading={isLoading}
        disabled={disabledButton}
        className={cn("flex w-full justify-between items-center gap-5 font-semibold text-sm p-0 hover:bg-transparent", type === PartnerType.CLT ? "text-black hover:text-black" : "text-white hover:text-white")}
      >
        {needAuthorization ? 'Autorizar' : 'Simular'}
        <ArrowRight size={18} color={type === PartnerType.CLT ? "black" : "white"} />
      </Button>

    </div>
  )
}